import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.scss';
import './styles/bootstrap.css';
import App from './components/App';
import store from './redux/store';

ReactDOM.render(<App store={store} />, document.getElementById('root'));
